import { createReducer } from 'utils/redux';

const SHOW_CONFIRM_MODAL = 'modal/SHOW_CONFIRM_MODAL';
const HIDE_CONFIRM_MODAL = 'modal/HIDE_CONFIRM_MODAL';

const initialState = {
  isConfirmModalVisible: false,
  confirmModalProps: {
    onConfirm: () => {
    },
    onCancel: () => {
    }
  }
};

export function showConfirmModal(confirmModalProps) {
  return {
    type: SHOW_CONFIRM_MODAL,
    payload: {
      confirmModalProps
    }
  };
}

export function hideConfirmModal() {
  return {
    type: HIDE_CONFIRM_MODAL,
    payload: {}
  };
}

export default createReducer('modal', initialState, {
  [HIDE_CONFIRM_MODAL]: (state) => ({
    ...state,
    confirmModalProps: initialState.confirmModalProps,
    isConfirmModalVisible: false
  }),
  [SHOW_CONFIRM_MODAL]: (state, { confirmModalProps }) => ({
    ...state,
    confirmModalProps,
    isConfirmModalVisible: true
  })
});
